// extracted by mini-css-extract-plugin
export var auto = "_2n-1";
export var spinner = "_2n-0";